import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router, RouterModule, NavigationEnd} from "@angular/router";

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor(private route:ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
  }

}
